import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ChannelTemplate } from "../../../../../domain/channel-template";

@Component({
  selector: "template-item",
  templateUrl: "./template-item.component.html",
  styleUrls: ["./template-item.component.scss"],
})
export class ChooseTemplateItemComponent implements OnInit {
  @Input()
  template: ChannelTemplate;

  @Output()
  onTemplateClicked: EventEmitter<ChannelTemplate> =
    new EventEmitter<ChannelTemplate>();

  constructor(private element: ElementRef) {}

  ngOnInit() {
    let videoElement = this.getVideoElement();
    videoElement.muted = true;
    videoElement.play();
  }

  getVideoElement(): HTMLVideoElement {
    return this.element.nativeElement.querySelector("video");
  }

  chooseTemplateClicked(template: ChannelTemplate) {
    this.onTemplateClicked.emit(template);
  }
}
